{
  "name": "kiosk",
  "version": "7.0.21",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration production --aot=true --base-href /kiosk/ && npm run sentry:sourcemaps",
    "build-dev": "ng build --configuration dev --aot=true --base-href /kiosk/",
    "test": "ng test",
    "lint": "ng lint --fix",
    "e2e": "ng e2e",
    "prebuild": "npm --no-git-tag-version version patch",
    "update": "ng update @angular/core@20 @angular/cli@20 --force",
    "cf": "ng generate @angular/core:control-flow",
    "standlonw": "ng generate @angular/core:standalone",
    "state-migration": "ng update @ngrx/store@18",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org zendynamix --project iotzen-kiosk ./dist && sentry-cli sourcemaps upload --org zendynamix --project iotzen-kiosk ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.2",
    "@angular/cdk": "^20.2.5",
    "@angular/common": "^20.3.2",
    "@angular/compiler": "^20.3.2",
    "@angular/core": "^20.3.2",
    "@angular/forms": "^20.3.2",
    "@angular/platform-browser": "^20.3.2",
    "@angular/platform-browser-dynamic": "^20.3.2",
    "@angular/router": "^20.3.2",
    "@angular/service-worker": "^20.3.2",
    "@ngrx/effects": "^20.0.0",
    "@ngrx/store": "^20.0.0",
    "@ngx-translate/core": "^16.0.4",
    "@primeng/themes": "^20.1.2",
    "@sentry/angular": "^10.15.0",
    "@zdIOTPlatform/ng-iot-printers": "1.3.8",
    "@zdIOTPlatform/zen-tax": "^1.0.16",
    "firebase": "^11.1.0",
    "primeicons": "^7.0.0",
    "primeng": "^20.1.2",
    "razorpay": "^2.9.5",
    "rxjs": "~7.8.1",
    "simple-keyboard": "^3.8.25",
    "simple-keyboard-layouts": "^3.4.51",
    "socket.io-client": "^4.8.1",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.3",
    "@angular/cli": "^20.3.3",
    "@angular/compiler-cli": "^20.3.2",
    "@ngrx/store-devtools": "^20.0.0",
    "@sentry/cli": "^2.40.0",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^22.10.5",
    "@types/w3c-web-usb": "^1.0.10",
    "angular-eslint": "18.0.1",
    "codelyzer": "^6.0.2",
    "eslint": "^9.5.0",
    "jasmine-core": "~5.1.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.1",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage-istanbul-reporter": "~2.1.0",
    "karma-jasmine": "~3.0.1",
    "karma-jasmine-html-reporter": "^1.4.2",
    "protractor": "~7.0.0",
    "ts-node": "~10.9.2",
    "tslint": "~6.1.3",
    "typescript": "~5.9.2",
    "typescript-eslint": "8.0.0-alpha.20"
  }
}